document.addEventListener('DOMContentLoaded', function () {
    const cartIcon = document.querySelector('#cart-icon-bubble');
    if (!cartIcon)
        return;
    const cartFloating = document.querySelector('.cart-floating');
    if (!cartFloating)
        return;

    cartIcon.addEventListener('click', function (evt) {
        evt.preventDefault();
        cfFloating.toggleCartPanel();
    });

    document.querySelector('.cf-btn-close').addEventListener('click', function () {
        cfFloating.toggleCartPanel(true);
    });
    document.querySelector('.cart-floating .cf-btn-order').addEventListener('click', function (evt) {
        if (!evt.target.closest('.cf-btn-order').classList.contains('cf-active')){
            evt.preventDefault();
        }
    });

    document.querySelectorAll('.quick-add-cart-btn').forEach( function (el){
        el.addEventListener('click', async function (evt){
            const btn = evt.target.closest('.quick-add-cart-btn');
            let variantId = btn.getAttribute('data-variant-id');
            if (!variantId)
                return;
            variantId = Number(variantId);
            btn.disabled = true;
            btn.querySelector('.loading__spinner').classList.remove('hidden');
            const res = await cfFloating.addProductToCart(variantId, 1);
            /*let isInStock = true;
            if (res){
                const itemAdded = res.items.find(item=> item.id == variantId);
                if (itemAdded) {
                    isInStock = await cfFloating.isProductInStock(itemAdded.handle, variantId);
                }
            }
            if (!isInStock){
                btn.querySelector('.sold-out-message').classList.remove('hidden');
                btn.querySelector('.add-cart-msg').remove();
            }
            else
                btn.disabled = false;*/
            btn.disabled = false;
            btn.querySelector('.loading__spinner').classList.add('hidden');
        });
    });


    const originalFetch = window.fetch;
    window.fetch = async function (input, init) {
        const url = typeof input === 'string' ? input : input.url;

        const response = await originalFetch(input, init);

        if (url.includes('/cart/add')) {
            const cloned = response.clone();
            cloned.json().then(data => {
                cfFloating.afterAddCart(data);
            }).catch(() => {});
        }

        return response;
    };
    const btnCloseMenu = document.querySelector('.menu-drawer__heading-btn-close');
    if (btnCloseMenu){
        btnCloseMenu.addEventListener('click', function (){
            document.body.classList.remove('overflow-hidden-tablet');
        });
    }

    let confirmRemoveCartItemPopup = document.querySelector('#removeCartItemPopup');
    if (confirmRemoveCartItemPopup){
        const crcipClone = confirmRemoveCartItemPopup.cloneNode(true);
        document.body.appendChild(crcipClone);
        confirmRemoveCartItemPopup.remove();
        confirmRemoveCartItemPopup = document.querySelector('#removeCartItemPopup');
        cfFloating.initConfirmPopupEvents(confirmRemoveCartItemPopup);
    }

    document.addEventListener('click', function (evt) {
        if (evt.target == document.querySelector('.cf-overlay')) {
            cfFloating.toggleCartPanel(true);
        }
        else if (evt.target === confirmRemoveCartItemPopup){
            confirmRemoveCartItemPopup.classList.add('hidden');
        }
    });
});
const cfFloating = {
    updateCartTimeout: null,
    toggleCartPanel: function (forceHide) {
        const cartFloating = document.querySelector('.cart-floating');
        if (!cartFloating) {
            return;
        }
        if (forceHide && cartFloating.classList.contains('hidden')) {
            return;
        }
        if (cartFloating.classList.contains('hidden') && !forceHide) {
            cartFloating.classList.remove('hidden');
            document.body.classList.add('overflow-hidden');
            this.getCartData();
            setTimeout(function () {
                cartFloating.classList.add('cf-active');
            }, 10);
        } else {
            cartFloating.classList.remove('cf-active');
            document.body.classList.remove('overflow-hidden');
            setTimeout(function () {
                cartFloating.classList.add('hidden')
            }, 250);
        }
    },
    getCartData: async function() {
        let cartData;
        try {
            const res = await fetch(`${window.Shopify.routes.root}cart.json`);
            cartData = await res.json();
        } catch (e) {
            cartData = null;
        }
        if (!cartData)
            return;
        let listHtml = '';
        const self = this;
        cartData.items.forEach(function (item) {
            listHtml += `<div class="cf-p-item p-5 border-b border-b-gray-500 gap-4 first:border-t first:border-t-gray-500" data-key="${item.key}" >
              <div class="cf-p-item-img flex-shrink-0">
                <img src="${item.featured_image.url}" 
                    alt="${item.featured_image.alt}" width="${item.featured_image.width}"
                    height="${item.featured_image.height}" class="w-full h-full" />
              </div>
              <div class="cf-p-item-detail">
                <p class="cf-pi-title text-sky-700">${item.title}</p>
                <div class="cf-pi-info mt-1 flex justify-between items-center">
                    <div class="cf-pi-price">${self.displayPrice(item.discounted_price)}</div>
                    <div class="cf-pi-control flex gap-1">
                        <button type="button" class="cf-pi-btn-ctrl btn-ctrl-down js-btn-qty-down w-12 h-12 bg-gray-200 hover:bg-gray-300 cursor-pointer flex items-center justify-center rounded-xl">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />
                            </svg>
                        </button>
                        <input type="number" min="1" step="1" value="${item.quantity}" data-key="${item.key}" class="cf-pi-input-qty w-24 h-12 border border-gray-500 rounded-xl !px-2 !py-1 !focus:outline-none !focus-visible:outline-none" />
                        <button type="button" class="cf-pi-btn-ctrl js-btn-qty-up btn-ctrl-up w-12 h-12 bg-gray-200 hover:bg-gray-300 cursor-pointer flex items-center justify-center rounded-xl">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                            </svg>
                        </button>
                    </div>
                    <div class="cf-pi-action">
                        <button type="button"  data-key="${item.key}" class="cf-pi-btn-remove border-none flex items-center justify-center w-8 h-8 !text-zinc-500 hover:!text-red-700 cursor-pointer">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="size-6" fill="currentColor" stroke="none">
                                <path d="M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z"/>
                            </svg>
                        </button>
                    </div>
                </div>
              </div>
        </div>`;
        });
        document.querySelector('.cart-floating .cf-list-products').innerHTML = `<div class="block mt-4">${listHtml}</div>`;

        self.updateGeneralInfo(cartData);
        document.querySelectorAll('.cart-floating .js-btn-qty-down, .cart-floating .js-btn-qty-up').forEach(function (el){
            el.addEventListener('click', function (evt){
                const qtyInput = evt.target.closest('.cf-pi-control').querySelector('.cf-pi-input-qty');
                let qtyValue = parseInt(qtyInput.value || '0');
                if (evt.target.closest('button').classList.contains('js-btn-qty-down')){
                    qtyValue = qtyValue > 1 ? (qtyValue - 1) : 0
                }
                else{
                    qtyValue++
                }
                qtyInput.value = qtyValue;
                const changeEvent = new Event('change', {
                    bubbles: true,
                    cancelable: true
                });
                qtyInput.dispatchEvent(changeEvent);
            });
        });
        document.querySelectorAll('.cart-floating .cf-pi-input-qty').forEach(function (el){
            el.addEventListener('change', function (evt){
                const qty = evt.target.value;
                const id = evt.target.getAttribute('data-key');
                if (self.updateCartTimeout){
                    clearTimeout(self.updateCartTimeout);
                }
                self.updateCartTimeout = setTimeout(function (){
                    if (Number(qty) <= 0){
                        self.confirmDeleteCartItem(id);
                        return;
                    }
                    self.updateProductQuantity(id, qty);
                }, 500);
            });
        });
        document.querySelectorAll('.cart-floating .cf-pi-btn-remove').forEach(function (el){
            el.addEventListener('click', function (evt){
                const id = evt.target.closest('button').getAttribute('data-key');

                self.confirmDeleteCartItem(id);
            });
        });
    },
    numberToPrice: function (nb) {
        let hasDecimal = true;
        if (typeof CF_CURRENCY_FORMAT === 'string' && CF_CURRENCY_FORMAT.includes('no_decimals')) {
            hasDecimal = false;
        }
        nb = (nb || 0) + '';
        if (!nb || !nb.match(/\d+/)) {
            return hasDecimal ? 0.00.toFixed(2).toString() : 0;
        }
        nb = nb.replace(/(\d{2})$/, '.$1');
        return hasDecimal ? parseFloat(nb).toFixed(2).toString() : parseFloat(nb);
    },
    numberWithCommas: function (nb) {
        if (!nb) return nb;
        return nb.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    displayPrice: function (price) {
        price = this.numberWithCommas(this.numberToPrice(price));
        if (typeof CF_CURRENCY_FORMAT === 'undefined')
            return price;
        return CF_CURRENCY_FORMAT.replace(/\{\{([^\}]+)\}\}/, price)
    },
    updateProductQuantity: async function (id, quantity){
        try{
            const res = await fetch(`${window.Shopify.routes.root}cart/change.json`,{
                method: "POST",
                body: JSON.stringify({id, quantity}),
                headers: {
                    "Content-type": "application/json; charset=UTF-8"
                }
            });
            const cartData = await res.json();
            this.checkCartData(cartData);
            this.updateGeneralInfo(cartData);
        }
        catch (e){
            console.log('-- Error update cart ---');
            console.log(e)
        }
        document.addEventListener('DOMContentLoaded', function () {
            const cartIcon = document.querySelector('#cart-icon-bubble');
            if (!cartIcon)
                return;
            const cartFloating = document.querySelector('.cart-floating');
            if (!cartFloating)
                return;

            cartIcon.addEventListener('click', function (evt) {
                evt.preventDefault();
                cfFloating.toggleCartPanel();
            });

            document.querySelector('.cf-btn-close').addEventListener('click', function () {
                cfFloating.toggleCartPanel(true);
            });
            document.querySelector('.cart-floating .cf-btn-order').addEventListener('click', function (evt) {
                if (!evt.target.closest('.cf-btn-order').classList.contains('cf-active')){
                    evt.preventDefault();
                }
            });
            document.addEventListener('click', function (evt) {
                if (evt.target == document.querySelector('.cf-overlay')) {
                    cfFloating.toggleCartPanel(true);
                }
            });


            const originalFetch = window.fetch;
            window.fetch = async function (input, init) {
                const url = typeof input === 'string' ? input : input.url;

                const response = await originalFetch(input, init);

                if (url.includes('/cart/add')) {
                    const cloned = response.clone();
                    cloned.json().then(data => {
                        console.log('🎯 Intercepted fetch add to cart:', data);
                        cfFloating.afterAddCart(data);
                    }).catch(() => {});
                }

                return response;
            };

        });

    },
    updateGeneralInfo: function (cartData){
        document.querySelector('.cart-floating .js-total-product').innerHTML = cartData.item_count || 0;
        document.querySelector('.cart-floating .js-total-price').innerHTML = this.displayPrice(cartData.items_subtotal_price);
        document.querySelector('.cart-floating .js-shipping-fee').innerHTML = cartData.requires_shipping ? 'Gratis' : 'Gratis';
        const btnCheckout = document.querySelector('.cart-floating .cf-btn-order');
        if (cartData.item_count)
            btnCheckout.classList.add('cf-active')
        else
            btnCheckout.classList.remove('cf-active');
    },
    afterAddCart: function (cartData){
        this.toggleCartPanel();
    },
    addProductToCart: async function (variantId, quantity){
        const formData = {
            'items': [{
                'id': variantId,
                'quantity': quantity
            }]
        };
        try {
            const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });
            const cartData = await res.json();
            this.checkCartData(cartData);
            return cartData;
        }
        catch (e){
            console.log('error add cart', e);
            return null;
        }
    },
    checkCartData: function (cartData){
        const cartIconBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
        if (cartData?.item_count == 0){
            cartIconBubble?.remove();
        }
        else if (cartData?.item_count && cartIconBubble){
            cartIconBubble.innerHTML = cartData.item_count;
        }
    },
    isProductInStock: async function (handle, variantId){
        try {
            const res = await fetch(window.Shopify.routes.root + `products/${handle}.js`);
            const product = await res.json();
            const variant = product.variants.find(v => v.id === variantId);
            if (variant){
                return variant.available;
            }
            return false;
        }
        catch (e){
            console.log('error add cart', e);
            return false;
        }
    },
    initConfirmPopupEvents: function (popup){
        const self = this;
        popup.querySelectorAll('.btn-close, .btn-keep-item').forEach(function (el){
            el.addEventListener('click', function (){
                popup.classList.add('hidden');
            });
        });

        popup.querySelector('.btn-remove-item').addEventListener('click', async function (evt){
            const btnRemove = evt.target.closest('button');
            const variantId = evt.target.closest('.rci-popup').querySelector('input[name="variantId"]').value;
            if (variantId) {
                btnRemove.disabled = true;
                btnRemove.style.opacity = '0.85';
                btnRemove.querySelector('.loading__spinner').classList.remove('hidden');
                await self.updateProductQuantity(variantId, 0);
                const cartItem = document.querySelector(`.cart-floating .cf-p-item[data-key="${variantId}"]`);
                if (cartItem){
                    cartItem.remove();
                }
                btnRemove.disabled = false;
                btnRemove.style.opacity = 1;
                btnRemove.querySelector('.loading__spinner').classList.add('hidden');
            }
            popup.classList.add('hidden');
        });

    },
    confirmDeleteCartItem: function (itemId){
        const confirmPopup = document.querySelector('#removeCartItemPopup');
        confirmPopup.querySelector('input[name="variantId"]').value = itemId;
        confirmPopup.classList.remove('hidden');
    }
};


